import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';
import closeIcon from 'public/static/images/paid_landing/close.svg';
import searchIcon from 'public/static/images/paid_landing/search-icon.svg';

export const styles = css`
  .search-container {
    display: flex;
    flex-direction: column-reverse;
    flex-grow: 1;
    position: relative;
  }

  .header-container {
    display: flex;
    height: 64px;
    align-items: center;
    padding: 21px 25px 21px 16px;
    width: 100%;
  }

  .spacer {
    height: 1px;
    background-color: ${colors.G2};
  }

  .search-icon {
    height: 26px;
    width: 26px;
    background: url(${searchIcon});
    background-size: cover;
  }

  .close-button {
    height: 26px;
    width: 26px;
    background: url(${closeIcon});
    background-size: cover;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }
`;
